var _circle, _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoSubmission(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 140,
    viewBox: "0 0 140 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 70,
    cy: 70,
    r: 70,
    fill: "#F2FBFD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.2051 121.381C28.6147 119.216 22.8496 112.752 28.5126 104.217C35.5914 93.5485 51.1264 90.7478 53.5499 95.0588C55.9734 99.3698 52.9368 106.081 46.863 106.535C40.7892 106.989 30.5454 94.7504 41.1043 79.649C49.5514 67.568 59.7443 63.4524 63.7849 62.9047",
    stroke: "#0096C7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M69.5089 66.4972L124.233 35.6881L83.7876 83.2998L69.5089 66.4972Z",
    fill: "white",
    stroke: "#90E0EF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M123.999 35.5002L74.4993 71.5063L69.4999 66.0069L123.999 35.5002Z",
    fill: "#E4F7FB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M69.4233 66.7094L46.0547 38.6756L126.26 33.9966L69.4233 66.7094Z",
    fill: "#3DB9E1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M62.5083 57.3188L59.2395 71.2465L120.848 36.4873L62.5083 57.3188Z",
    fill: "white",
    stroke: "#90E0EF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoSubmission);
export default __webpack_public_path__ + "static/media/NoSubmission.729d5e63078a3d5ce0bc111405027e67.svg";
export { ForwardRef as ReactComponent };